<template>
  <div v-if="showVoucherCampaigns" class="voucher-campaigns__container">
    <h3 class="voucher-campaigns__header">Gift Subscription Offer:</h3>
    <div v-for="(c, index) in voucherCamapigns" :key="`VoucherCamaign::${index}`" class="voucher-campaign" @click="handleClickVoucherCampaign(c)">
      <div class="voucher-campaign__checkbox-container">
        <input class="voucher-campaign__checkbox" type="checkbox" :checked="c.selected === true" :label="c.tag" name="voucherTypeId" />
      </div>
      <div class="voucher-campaign__img">
        <img :src="createImgixURL(c)" :alt="c.campaign" loading="lazy" />
      </div>

      <div class="voucher-campaign__description">
        <p>
          Yes, please email me a <span>{{ c.campaign }}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CheckoutCartVoucherCampaign',
  serverCacheKey() {
    return false
  },
  data() {
    return {
      imgixQS: '?fm=png&auto=format&fit=fill&fill=solid&bg=0FFF&w=140',
      uniqueVoucherTags: undefined,
      selectedVoucherTag: undefined,
      selectedVoucherCampaing: undefined,
      showVoucherCampaigns: false
    }
  },
  computed: {
    ...mapGetters({
      basket: 'basket/payload',
      basketId: 'basket/id',
      basketItems: 'basket/items',
      voucherCamapigns: 'cart/VoucherCamapigns'
    })
  },

  async created() {
    this.$nuxt.$on('GIFT_OPTION_CHANGE', ({ id, checked, flag }) => {
      if (this.$config.VoucherCampaignEnabled === false) {
        return
      }

      console.info(`VOUCHER_CAMAPINGS GIFT_OPTION_CHANGE id=${id} checked=${checked} flag=${flag}`)

      console.info(`VOUCHER_CAMAPINGS GIFT_OPTION_CHANGE CURRENT showVoucherCampaigns=${this.showVoucherCampaigns}`)

      let localShowVoucherCampaigns = false
      for (let i = 0; i < this.basketItems.length; i++) {
        if (this.voucherCamapigns && this.voucherCamapigns.length > 0) {
          let ret = false
          const item = this.basketItems[i]
          console.info(`CHECKING ITEMS id=${item.id} item=`, item)

          // Check for any available Use Cases
          if (item && this.$config.VoucherCampaignGiftLogic === true) {
            // Check for VOUCHER_CAMPAING_GIFT_LOGIC
            // 1) The option.allow_as_gift Flag has been checked
            // 2) It is a Gift offer
            if (item && item?.offer?.voucher_tag !== undefined) {
              const voucherCampaingOfferTag = item.offer.voucher_tag
              const voucherCampaignExist = this.voucherCamapigns.find(c => c.tag === voucherCampaingOfferTag)

              if (voucherCampaignExist && item?.options?.allow_as_gift === true) {
                // 1) The option.allow_as_gift Flag has been checked
                ret = true
              } else if (item?.is_gift === true) {
                // 2) It is a Gift offer
                ret = true
              }
            }
          }

          if (item && this.$config.VoucherCampaignXMASGiftLogic === true) {
            // Check for VOUCHER_CAMPAING_XMASGIFT_LOGIC
            // 1) The option.allow_as_xmas_gift Flag has been checked
            // 2) It is a XMAS Gift offer
            if (item && item?.offer?.voucher_tag !== undefined) {
              const voucherCampaingOfferTag = item.offer.voucher_tag
              const voucherCampaignExist = this.voucherCamapigns.find(c => c.tag === voucherCampaingOfferTag)

              if (voucherCampaignExist && item?.options?.allow_as_xmas_gift === true) {
                // 1) The option.allow_as_gift Flag has been checked
                ret = true
              } else if (item?.is_xmas_gift === true) {
                // 2) It is a XMAS Gift offer
                ret = true
              }
            }
          }
          console.info(`CHECKING ITEMS FOUND ret=`, ret)
          localShowVoucherCampaigns = localShowVoucherCampaigns || ret
        }
      }

      // if (ret === false) {
      //   this.$store.commit('cart/ToggleVoucherCampaingByTag', undefined)
      // }

      this.showVoucherCampaigns = localShowVoucherCampaigns || false
      console.info(`VOUCHER_CAMAPINGS GIFT_OPTION_CHANGE NEW showVoucherCampaigns=${this.showVoucherCampaigns}`)
    })

    if (this.$config.VoucherCampaignEnabled === false) {
      return
    }
    const voucherCamapigns = []
    // Check for an Available Voucher Tags
    this.uniqueVoucherTags = [...new Set(this.basketItems.map(item => item?.offer?.voucher_tag || undefined).filter(tag => tag !== undefined))]

    console.log('VOUCHER CAMPAIGN uniqueVoucherTags=', this.uniqueVoucherTags)

    if (this.uniqueVoucherTags && this.uniqueVoucherTags.length) {
      for (let index = 0; index < this.uniqueVoucherTags.length; index++) {
        const campaignTag = this.uniqueVoucherTags[index]
        console.log('CALLING Campaign API for campaignTag=', campaignTag)
        // CALL THE utility API to check if a Voucher Campaing is enabled
        const url = `${this.$config.APIProxyURL}/utility/tag/${campaignTag}/get-voucher-campaign-by-tag`
        const useCache = true
        let campaign = await this.$axios
          .$get(url, {
            headers: {
              'Content-Type': 'application/json',
              ...(this.$config.APIProxyAPIkey && { 'x-internal-proxy': this.$config.APIProxyAPIkey }),
              'Cache-Control': useCache ? 'max-age=3600' : 'max-age=0'
            },
            timeout: this.$config.AWSAPIGatewayTimeout,
            useCache
          })
          .then(function(response) {
            console.log('VOUCHER CAMPAIGN payload=', response.payload)
            return response.payload
          })
          .catch(function(error) {
            console.log('VOUCHER CAMPAIGN ERROR=', error)
            return {
              error
            }
          })

        // Add only the enabled Voucher Campaing
        if (campaign && campaign?.enabled === true) {
          const basketVoucherCampaign = this.basket?.voucher_campaign
          console.log(`#${index} VOUCHER CAMPAIGN basketVoucherCampaign=`, basketVoucherCampaign)
          let selected = false
          if (basketVoucherCampaign === undefined || basketVoucherCampaign === null) {
            selected = false
            console.log(`#${index} VOUCHER CAMPAIGN NULL selected=`, selected)
          } else {
            selected = basketVoucherCampaign.tag === campaign.tag
            console.log(`#${index} VOUCHER CAMPAIGN TAG selected=`, selected)
          }

          campaign = { ...campaign, selected }
          this.selectedVoucherTag = selected === true ? campaign.tag : undefined
          this.selectedVoucherCampaing = selected === true ? campaign : undefined
          console.log(`#${index} VOUCHER CAMPAIGN FOUND this.basket=`, this.basket)
          console.log(`#${index} VOUCHER CAMPAIGN FOUND campaign=`, campaign)
          console.log(`#${index} VOUCHER CAMPAIGN selected=`, selected)
          console.log(`#${index} VOUCHER CAMPAIGN selectedVoucherTag=`, this.selectedVoucherTag)
          console.log(`#${index} VOUCHER CAMPAIGN selectedVoucherCampaing=`, this.selectedVoucherCampaing)

          voucherCamapigns.push(campaign)
        }
      }

      // PUSH the Voucher Campaigns to the store
      this.$store.commit('cart/VoucherCamapigns', voucherCamapigns)

      // attribute showVoucherCampaigns LOGIC
      console.info(`VOUCHER_CAMAPINGS MOUNTED`)
      let ret = false
      for (let index = 0; index < this.basketItems.length; index++) {
        const item = this.basketItems[index]
        if (this.voucherCamapigns && this.voucherCamapigns.length > 0) {
          // Check for any available Use Cases
          if (item && this.$config.VoucherCampaignGiftLogic === true) {
            // Check for VOUCHER_CAMPAING_GIFT_LOGIC
            // 1) The option.allow_as_gift Flag has been checked
            // 2) It is a Gift offer
            if (item && item?.offer?.voucher_tag !== undefined) {
              const voucherCampaingOfferTag = item.offer.voucher_tag
              const voucherCampaignExist = this.voucherCamapigns.find(c => c.tag === voucherCampaingOfferTag)

              if (voucherCampaignExist && item?.options?.allow_as_gift === true) {
                // 1) The option.allow_as_gift Flag has been checked
                ret = true
                break
              } else if (item?.is_gift === true) {
                // 2) It is a Gift offer
                ret = true
                break
              }
            }
          }

          if (item && this.$config.VoucherCampaignXMASGiftLogic === true) {
            // Check for VOUCHER_CAMPAING_XMASGIFT_LOGIC
            // 1) The option.allow_as_xmas_gift Flag has been checked
            // 2) It is a XMAS Gift offer
            if (item && item?.offer?.voucher_tag !== undefined) {
              const voucherCampaingOfferTag = item.offer.voucher_tag
              const voucherCampaignExist = this.voucherCamapigns.find(c => c.tag === voucherCampaingOfferTag)

              if (voucherCampaignExist && item?.options?.allow_as_xmas_gift === true) {
                // 1) The option.allow_as_gift Flag has been checked
                ret = true
                break
              } else if (item?.is_xmas_gift === true) {
                // 2) It is a XMAS Gift offer
                ret = true
                break
              }
            }
          }
        }
      }

      this.showVoucherCampaigns = ret
    }
  },

  methods: {
    createImgixURL(campaign) {
      return `${this.$config.imgixURL}${campaign.image_path}${this.imgixQS}`
    },
    async handleClickVoucherCampaign(campaign) {
      if (this.selectedVoucherTag === campaign.tag) {
        this.selectedVoucherTag = undefined
        this.selectedVoucherCampaing = undefined
      } else {
        this.selectedVoucherTag = campaign.tag
        this.selectedVoucherCampaing = campaign
      }

      // Update the Selected Voucher Campaign on the state
      this.$store.commit('cart/ToggleVoucherCampaingByTag', this.selectedVoucherTag)
      console.log(`handleClickVoucherCampaign slected tag=${this.selectedVoucherTag} campaign=`, campaign)

      // Update the Voucher Campaing via the basket API
      const data = {
        voucher_campaign: this?.selectedVoucherCampaing || null
      }

      this.isLoading = true
      const url = `${this.$config.APIProxyURL}/basket/id/${this.basketId}/update-funnel-info`
      console.info(`handleClickVoucherCampaign data=`, data)
      console.info(`handleClickVoucherCampaign url=${url}`)

      const config = {
        method: 'put',
        maxBodyLength: Infinity,
        url,
        headers: {
          'Cache-Control': 'max-age=0',
          'Content-Type': 'application/json'
        },
        data
      }

      await this.$axios
        .request(config)
        .then(response => {
          console.info('handleClickVoucherCampaign payload=', response.data.payload)

          // UPDATE The Basket on the Storage
          this.$store.commit('basket/payload', response.data.payload)

          return response.data.payload
        })
        .catch(error => {
          console.error('handleClickVoucherCampaign error=', error)
          return false
        })

      this.isLoading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.voucher-campaigns {
  &__container {
    display: flex;
    flex-direction: column;
    padding-bottom: 15px;
  }
  &__header {
    color: #000;
    font-weight: 700;
    font-size: 16px;
    line-height: 23.4px;
    padding-bottom: 5px;
    margin: 0 0 15px;
    border-bottom: 1px solid #ccc;
  }
}
.voucher-campaign {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: #ededed;
  }
  &__checkbox-container {
    display: block;
  }
  input {
    appearance: auto !important;
    -webkit-appearance: auto !important;
    display: block;
    pointer-events: none;
    margin: 10px;
  }
  img {
    max-height: 90px;
    max-width: 200px;
    padding: 10px;
  }
}
</style>
